import { PushNotifications } from '@capacitor/push-notifications';
import { isNative } from './capacitor';

/**
 * Request permission and return the device FCM token.
 * Resolves to null on web or when permission is denied.
 * Must NOT block the initial render — call this after first paint.
 */
export async function registerAndGetToken() {
  if (!isNative()) return null;

  const { receive } = await PushNotifications.requestPermissions();
  if (receive !== 'granted') return null;

  await PushNotifications.register();

  return new Promise((resolve) => {
    PushNotifications.addListener('registration', ({ value }) => resolve(value));
    PushNotifications.addListener('registrationError', () => resolve(null));
  });
}
